<template lang="pug">
  a.social-card.animated(
    v-lazyload
    :href="item.link"
    target="_blank"
    rel="noopener noreferrer"
  )
    img(v-lazyload :data-src="item.image" alt="")
</template>

<script>
export default {
  name: 'SocialsListItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    link: vm => vm.item.link || ''
  }
}
</script>
